﻿import axios from 'axios';
import {APIUrl} from '../constants/ApplicationConstants.js';
import adviceFeeActions from '../actions/AdviceFeeAction.js';
import ApplicationApiCallBackActions from '../actions/ApplicationApiCallBackActions.js';
import {getError as Error, ThrowIfStatusNotOk} from './ApiHelper.js';

﻿module.exports = {
﻿    excessiveFeeCheck: function(accountBalance, oneoffFeeAmount, ongoingFeeAmount, ongoingPercent) {
﻿        const url = APIUrl.BASE_ADVISERS_URL +
﻿            APIUrl.ADVISER_FEE_URL +
﻿            APIUrl.CHECK_FOR_EXCESSIVE_FEE +
﻿            '?accountBalance=' +
﻿            accountBalance +
﻿            '&oneOffFee=' +
﻿            oneoffFeeAmount +
﻿            '&ongoingFee=' +
﻿            ongoingFeeAmount +
﻿            '&ongoingPercent=' +
﻿            ongoingPercent;

﻿        axios.get(url)
﻿            .then(ThrowIfStatusNotOk)
﻿            .then((response) => {
﻿                adviceFeeActions.getExcessiveFeeCheckResult(response.data);
﻿            })
﻿            .catch((error) => {
﻿                throw Error('Exessive fee check', error);
﻿            });
﻿    },

﻿    checkAdviserFeeFlag: function() {
﻿        const url = APIUrl.BASE_ADVISERS_URL + APIUrl.ADVISER_FEE_URL + APIUrl.GET_ADVISER_SERVICE_FLAGS;

﻿        axios.get(url)
﻿            .then(ThrowIfStatusNotOk)
﻿            .then((response) => {
﻿                ApplicationApiCallBackActions.setAdviserFeeTypeOptions(response.data);
﻿            })
﻿            .catch((error) => {
﻿                throw Error('Check adviser fee flag', error);
﻿            });
﻿    }
﻿};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./apis/AdviceFeeAPI.js